import { Env } from '@repo/types/config';
import { WidgetStudy } from '@repo/types/models';
import { ThemeProvider } from '@repo/ui/theme';
import { PropsWithChildren, useLayoutEffect } from 'react';
import { envController } from '../utils/env';
import { StudyProvider } from '../utils/StudyContext';
import { T, TranslationsProvider } from '../utils/TranslationsContext';

export type MainAppContainerProps = {
    translation: T;
    env: Env;
    study: WidgetStudy;
    fullPage: boolean;
};

export default function MainAppContainer(
    props: PropsWithChildren<
        MainAppContainerProps & { shouldExcludeFont?: boolean }
    >,
) {
    // Need to run this before the UI is mounted so that if there are some calls to the backend, its teh correct ones
    useLayoutEffect(() => {
        envController.setCurrentEnv(props.env);
    }, [props.env]);

    return (
        <ThemeProvider
            themeName={props.study.theme || 'default'}
            shouldExcludeFont={props.shouldExcludeFont}
        >
            <TranslationsProvider t={props.translation}>
                <StudyProvider initStudy={props.study}>
                    {props.children}
                </StudyProvider>
            </TranslationsProvider>
        </ThemeProvider>
    );
}
